<template>
  <div class="special">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt="">
      </a> -->
    </div>
    <div class="content">
      <ul class="msg_list">
        <li v-for="(item,index) in firstList" :key="index">
          <a class="lv_1" href="javascript:;" @click="check(item.id,item)">
            【{{item.name}}】
          </a>
          <a class="lv_2" href="javascript:;" v-for="(subList,index) in item.subList" :key="index" @click="checkSub(subList.id,subList,item.id)">
            {{subList.name}}
          </a>
        </li>
        <li>
          <a class="lv_1" href="javascript:;" v-for="(item,index) in twoList" :key="index" @click="check(item.id,item)">
            【{{item.name}}】
          </a>
        </li>
        <li>
          <a class="lv_1" href="javascript:;" v-for="(item,index) in thirdList" :key="index" @click="check(item.id,item)">
            【{{item.name}}】
          </a>
        </li>
        <li  v-for="(item,index) in list" :key="item.id" v-show="index>5" >
          <a class="lv_1" href="javascript:;" @click="check(item.id,item)">
            【{{item.name}}】
          </a>
          <a class="lv_2" href="javascript:;" v-for="(subList,index) in item.subList" :key="index" @click="checkSub(subList.id,subList,item.id)">
            {{subList.name}}
          </a>
        </li>
        <li>
          <a class="lv_1 uelite" href="javascript:;" @click="$router.push('user')">
            【uelite会员登录】
          </a>
        </li>
      </ul>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
      list:[],
      firstList:[],
      twoList:[],
      thirdList:[]

    }
  },
  created() {
    this.getList();
  },
  methods: {
    /* 获取菜单 */
    getList() {
      this.$axios.get('/api/web/phone/category/list-with-structure', {}).then(res => {
        this.list = res.data;
        console.log(this.list)
        this.firstList.push(this.list[0]);
        console.log(this.firstList)
        this.twoList.push(this.list[1],this.list[2],this.list[3]);
        this.thirdList.push(this.list[4],this.list[5]);
      })
    },
    // 点击菜单
    check(num,item){
      console.log('num', item)
      if(num==4){
        // 点击专栏
        this.$router.push({ name:"special", query: { id: num }});
      }else if(num==9){
         // 点击活动
        this.$router.push({ name:"event", query: { id: num }});
      }else if(num!=4&&num!=9 &&item.subList.length==0){
        // 列表
        this.$router.push({ name:"list", query: { id: num }});
      }else if(num!=4&&num!= 9&&item.subList.length!=0){
        // 带二级菜单列表
        this.$router.push({ name:"sub-list", query: { id: num }});
      }
    },
    // 点击菜单
    checkSub(num,item,parentNum){
      this.$router.push({ name:"sub-list", query: { id: num ,parentId: parentNum}});
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .special {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
   .header{
    height: 54px;
    background: rgb(255, 255, 255);
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 133px;
      // height: 38px;
      position: absolute;
      top: 10px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        height:40px;
      }
    }
  }
  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 54px;
    .search{
      position: relative;
      height: 57px;
      background: #EEEEEE;
      input{
        position: absolute;
        left: 15px;
        top: 10px;
        width:267px;
        height:37px;
        background:#fff;
        border-radius:5px;
        border:1px solid #CACACA;
        padding-left: 25px;
        box-sizing: border-box;
      }
      .search_btn{
        position: absolute;
        right: 15px;
        top: 10px;
        width:64px;
        height:37px;
        background: #0C324C;
        border-radius:5px;
        color: #fff;
        font-size: 16px;
        line-height: 37px;
      }
    }
    .msg_list{
      padding: 0 15px;
      li{
        border-bottom: 1px solid #E0E0E0;
        padding: 15px 0;
        text-align: left;
      }
      .lv_1{
        display: inline-block;
        color: #333333;
        font-size: 16px;
        line-height: 22px;
      }
      .lv_2{
        display: inline-block;
        padding: 5px;
        color: #666666;
        font-size: 14px;
        line-height: 22px;
      }
      .uelite{
        color: #DF964D;
      }
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/more.vue